/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import TrackingModel from '@/api/tracking/tracking.model';

/**
 * Component.
 */
@Component({ name: 'delivered-service-point-component' })
export default class extends Vue {
  /**
   * Property `windowHeight`;
   */
  windowHeight = null;

  /**
   * Property `client`.
   */
  @Prop({ type: String })
  client: string;

  /**
   * Property `servicePoint`.
   */
  @Prop({ default: null, type: String })
  servicePoint: string;

  /*
   * Property `tracking`.
   */
  @Prop({ type: Object })
  tracking: TrackingModel;

  /**
   * Property `orderType`.
   */
  @Prop({ default: null, type: String })
  orderType: string;

  /**
   * Property `numberOfPackages`.
   */
  @Prop({ default: 0, type: Number })
  numberOfPackages: number;

  /**
   * Getter `isDelivery`
   */
  get isDelivery() {
    return this.orderType === 'DELIVERY';
  }

  /**
   * Getter status title.
   */
  get statusTitle() {
    return this.i18n('TRACKING.SENTENCES.STATUS_HELLO', false, 'upperFirst', {
      name: this.client || '-'
    });
  }

  /**
   * Getter status sentence.
   */
  get statusSentence() {
    const { servicePoint: pickUp = null, tracking } = this || {};
    const { statusDate } = tracking || {};
    const date = statusDate
      ? this.$moment(statusDate).format('DD MMM YYYY')
      : '-';
    const hour = statusDate ? this.$moment(statusDate).format('HH:mm') : '-';

    const message = this.i18n(
      `TRACKING.SENTENCES.STATUS_${
        this.isDelivery ? 'DELIVERED' : 'COLLECTED'
      }_SERVICE_POINT`,
      false,
      'plain',
      {
        date: `<b>${date}</b>`,
        hour: `<b>${hour}</b>`,
        packages:
          this.numberOfPackages > 1
            ? this.i18n(
              'TRACKING.SENTENCES.NUMBER_OF_PACKAGES',
              false,
              'plain',
              { total: this.numberOfPackages }
            )
            : '',
        pickUp: `<b>${pickUp || '-'}</b>`
      }
    );

    return message;
  }

  /**
   * Getter `extraSmallScreenHeight`.
   */
  get extraSmallScreenHeight() {
    return this.windowHeight <= 320;
  }

  /**
   * Lifecycle mounted hook.
   */
  mounted() {
    this.handleOnResize();

    this.$nextTick(() => {
      window.addEventListener('resize', this.handleOnResize);
    });
  }

  /**
   * Lifecycle destroyed hook.
   */
  destroyed() {
    window.removeEventListener('resize', this.handleOnResize);
  }

  /**
   * Handle on resize.
   */
  handleOnResize() {
    this.windowHeight = window.innerHeight;
  }

  /**
   * Handle window height.
   */
  @Watch('windowHeight')
  handlewindowHeight(value) {
    this.windowHeight = value;
  }
}
